module.exports = __webpack_public_path__ + "static/media/refresh.95875b1c.svg";